module.exports = __webpack_public_path__ + "img/youhui.e26d86fd.png";